import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { BaseWizardService } from "../base.wizard.service";
import { ApiService, InputDatastoreService, DialogService, CountryListService, AgentDownloadDialogService } from "@nrwl/common-lib";
import { IPAMConfigWizardStep } from "./ipam.configuration.wizard.step";
import { takeUntil } from "rxjs/operators";
import { BehaviorSubject} from "rxjs";

export enum DataSource {
  GIGA_STOR = 'GigaStor',
  GIGA_FLOW_SERVER = 'GigaFlowServer',
  GIGA_TEST = 'GigaTestAgent'
}

@Injectable()
export class IPAMConfigWizardService extends BaseWizardService {
  openNew:boolean;
  state:ActivatedRoute;
  currentParam:any;
  closeWizard: BehaviorSubject<boolean>;
  
  constructor(
    dataApiService:ApiService,
    state: ActivatedRoute,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService) {
    super(dataApiService, inputDatastoreService, countryListService, dialogService);
    this.state = state;
    this.stepClass = IPAMConfigWizardStep;
    this.openNew = false;
    this.closeWizard = new BehaviorSubject(false);
  }

 //------------------------------------------------ Wizard control ----------------------------------------------------

 openWizard(
    wizardId,
    wizardConfig,
    defaultParamsById = {},
    onSuccess = () => {},
    onFail = () => {}
 ) {
    
   super.openWizard(wizardId, wizardConfig, defaultParamsById, onSuccess, onFail);
 }

  setNextStep() {
    super.setNextStep();
  }

  _setPreviousStep() {
      super._setPreviousStep();
  }

  onFinish() {
    const responseProcessed = this._saveWizardData();
    responseProcessed.subscribe(() => {
      this.currentStep = this.finishingStep;
      if(!this.requestFailed) {
        this.successMessage = 'InfoBlox Configuration has been successfully added';
      }
    });
    return responseProcessed;
  }

  showExitInsteadOfClose() {
    if (this.isFinishingStep() && (this.requestFailed || this.errorMessage)) {
      return true;
    }
    return false;
  }

}
